"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["onClick"];
const _hoisted_2 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "Enquiry", -1);
const vue_3 = require("vue");
const EnquiryForm_vue_1 = __importDefault(require("./EnquiryForm.vue"));
const TeleportModal_vue_1 = __importDefault(require("../modals/TeleportModal.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'EnquiryButton',
    props: {
        class: {
            type: String,
            default: 'button-mutedpurple-800',
        },
    },
    setup(__props) {
        const props = __props;
        const modalOpen = (0, vue_3.ref)(false);
        function openModal() {
            modalOpen.value = true;
        }
        function closeModal() {
            modalOpen.value = false;
        }
        return (_ctx, _cache) => {
            const _component_button_icon = (0, vue_2.resolveComponent)("button-icon");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createElementVNode)("button", {
                    type: "button",
                    onClick: (0, vue_2.withModifiers)(openModal, ["prevent"]),
                    class: (0, vue_2.normalizeClass)(["button button-outlined hover:button-mutedpurple-700 has-icon", __props.class])
                }, [
                    (0, vue_2.createVNode)(_component_button_icon),
                    _hoisted_2
                ], 10, _hoisted_1),
                (modalOpen.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(TeleportModal_vue_1.default, {
                        key: 0,
                        to: "body",
                        onClose: _cache[1] || (_cache[1] = ($event) => (modalOpen.value = false))
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createVNode)(EnquiryForm_vue_1.default, {
                                onClose: _cache[0] || (_cache[0] = ($event) => (modalOpen.value = false))
                            })
                        ]),
                        _: 1
                    }))
                    : (0, vue_2.createCommentVNode)("", true)
            ], 64));
        };
    }
});
